import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'customDefaultValueGridColumn',
})
export class CustomDefaultValueGridColumnPipe implements PipeTransform {
  transform(value: string | undefined, defaultValue = '--'): string {
    if (value) {
      return value;
    }
    return defaultValue;
  }
}
